<template>
	<div class="page">
		<Tip :title="title" />
		<div class="from_div">
			<el-table class="table_div" :data="tableData" :header-cell-style="tabStyle">
				<el-table-column label="编号" type="index" width="80">
				</el-table-column>
				<el-table-column label="订单信息" width="300">
					<template slot-scope="scope">
						<div class="col">
							<span>单号：{{scope.row.order_no}}</span>
							<span>下单：{{scope.row.created_time}}</span>
							<span>出货：{{scope.row.created_time}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="商品信息">
					<template slot-scope="scope">
						<div class="col">
							<span>名称：{{scope.row.good_name}}</span>
							<span>规格：{{scope.row.spec_data_str}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="数量">
					<template slot-scope="scope">
						<span>{{scope.row.quatity}}</span>
					</template>
				</el-table-column>
				<el-table-column label="单价">
					<template slot-scope="scope">
						<span>{{scope.row.cost_price}}</span>
					</template>
				</el-table-column>
				<el-table-column label="金额">
					<template slot-scope="scope">
						<span>{{scope.row.cost_amount}}</span>
					</template>
				</el-table-column>
				<el-table-column label="退货量">
					<template slot-scope="scope">
						<span>{{scope.row.after_quatity}}</span>
					</template>
				</el-table-column>
				<el-table-column label="退款额">
					<template slot-scope="scope">
						<span>{{scope.row.after_amount}}</span>
					</template>
				</el-table-column>
				<el-table-column label="小计" width="100">
					<template slot-scope="scope">
						<span>{{scope.row.total_amount}}</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="foot_div">
			<el-button @click="close(0)">返回</el-button>

            <el-pagination class="pagination" background layout="prev, pager, next,jumper, ->, total" :total="total"
				@current-change="handleCurrentChange" :currentPage="form.page" :pageSize="form.limit">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
    import {
		supplier,
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip
		},
        props: {
			type: {
				type: Number
			}
		},
		data() {
			return {
				title: '货品销售明细',
				input:'',
                total: 0,
				tableData: [],
                form: {
                    sku_id: 0,
                    page: 1,
                    limit: 10,
                }
			}
		},
		computed: {
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333'
				}
			}
		},
		mounted() {
            this.form.sku_id = this.type;
            this.getSupplierSaleLists();
        },
		methods: {
            getSupplierSaleLists(){
                supplier(this.form, 3).then(res => {
					if (res.code == 0) {
						this.total = res.count
						this.tableData = res.data
					}else{
                        return this.$message.error(res.msg);
                    }
				}).catch(err => {})
            },
            handleCurrentChange(page) {
				this.form.page = page; //每次点击分页按钮，当前页发生变化
				this.getSupplierSaleLists();
			},
			close(index) {
				this.$emit('close',index)
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
	}
	
	.table_div {
		width: 100%;
	}
	
	.from_div{
		padding-top: 20px;
		width: 100%;
		overflow: scroll;
		height: 605px;
		min-height: 100%;
		padding-bottom: 60px;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
        display: flex;
	}

	.span {
		font-size: 14px;
		color: #767676;
	}
    .pagination {
		display: flex;
		justify-content: right;
		padding: 20px 30px 20px 30px;
        flex: 1;
	}
</style>